<section class="cst_body">
    <!-- <div class="nav" >
        <ul>
            <li *ngIf="isSampleSubmissionMemo && selectedItems.length > 0">
                <button type="submit" class="paymentispbtn" [ngClass]="{'active' : isRefundbtn}" (click)="sampleSubmission()">Submit Samples</button>
            </li>
           
        </ul>
    </div> -->
  <div class="container-fluid search_flt_box_main">
    <div class="search_flt_box">
     
        <div class="row dataRow">
          <p class="col-md-3">
            Customer Name :
            <span class="nameEllip">{{orderDetailsRes[0]?.order?.patientinfo?.name}}</span>
          </p>
          <p class="col-md-2">
            MRN :
            <span>{{orderDetailsRes[0]?.order?.patientinfo?.mrn}}</span>
          </p>
          <p class="col-md-2">
            Service Type :
              <span *ngIf="orderDetailsRes[0]?.order?.patientinfo?.service_type == '5'">Care at Home</span>
              <span *ngIf="orderDetailsRes[0]?.order?.patientinfo?.service_type == '6'">Nursing</span>
              <span *ngIf="orderDetailsRes[0]?.order?.patientinfo?.service_type == '7'">Physiotherapy</span>
              <span *ngIf="orderDetailsRes[0]?.order?.patientinfo?.service_type == '8'">Bedside Attendant</span> 
              <span *ngIf="orderDetailsRes[0]?.order?.patientinfo?.service_type == '100'">Package</span>        
          </p>
          <p class="col-md-3">
            Order Created Date :
            <span>{{orderDetailsRes[0]?.order?.order_status?.created_date | date:'dd/MM/yyyy hh:mm a'}}</span>
          </p>
          <p class="col-md-2" *ngIf="orderDetailsRes[0]?.order?.patientinfo?.service_type != '100'" >Total no of Session :
            <span>{{orderDetailsRes[0]?.order?.business?.repeats * orderDetailsRes[0]?.order?.business?.sessionsPerDay}}</span>
          </p>
          <p class="col-md-2"  *ngIf="orderDetailsRes[0]?.order?.patientinfo?.service_type != '100'">Amount per Session :
            <span>{{amountPerSession | number:'1.0-2'}}</span>
          </p>
          <p class="col-md-2">Gross Amount :
            <span>{{orderDetailsRes[0]?.payment_info.gross_amount | number:'1.0-2'}}</span>
          </p>
          <p class="col-md-2">Discount Amount :
            <span>{{orderDetailsRes[0]?.payment_info.discount_amount | number:'1.0-2'}}</span>
          </p>
          <p class="col-md-2">Net Amount :
            <span>{{orderDetailsRes[0]?.payment_info.net_amount | number:'1.0-2'}}</span>
          </p>
          <p class="col-md-2">Paid Amount :
            <span>{{orderDetailsRes[0]?.payment_info.paid_amount | number:'1.0-2'}}</span>
          </p>
          <p class="col-md-2">Payable Amount :
            <span>{{orderDetailsRes[0]?.payment_info.payable_amount | number:'1.0-2'}}</span>
          </p>
        </div>
      
      <div class="row rowEnd" *ngIf="orderDetailsRes[0]?.order?.patientinfo?.service_type != '100'" >
        <button class="btn transpBtnMany ml-2"  (click)="openCancelModal(orderDetailsRes[0],15)" [disabled]="!checkedOrders.length"
          ><img src="assets/icons/req-cancel.svg"/>Request For Cancel <span *ngIf="checkedOrders.length > 0">({{checkedOrders.length}})</span></button>
        <div>
          <button class="btn transpBtnMany ml-2"
            (click)="openCompleteModal(orderDetailsRes[0].order.patientinfo.order_id,3,'complete')" [disabled]="!checkedOrders.length"
            ><img src="assets/icons/mark-ord-completed.svg"/>Complete  Orders <span *ngIf="checkedOrders.length > 0">({{checkedOrders.length}})</span> </button>
    
          <button type="button" class="btn transpBtnMany ml-2"  [disabled]="!checkedOrders.length"
            (click)="openReScheduleItemModal(orderDetailsRes[0],8)"><img src="assets/icons/cancel.svg"/>Cancel  Orders<span *ngIf="checkedOrders.length > 0">({{checkedOrders.length}})</span></button>
<!-- 
            <button type="button" class="btn orange_btn ml-2" *ngIf="checkedOrders.length > 0"
              (click)="openReScheduleItemModal(orderDetailsRes[0],8)">Cancel Bulk Orders</button> -->

              <button type="button" class="btn transpBtnMany ml-2"  [disabled]="!checkedOrders.length"
              (click)="openReAllocateModal('forceAllocate')" ><img src="assets/icons/allocate.svg"/>Allocate <span *ngIf="checkedOrders.length > 0">({{checkedOrders.length}})</span></button> 
        </div>
      </div>
    
    </div>
    <div class="customer_dtl_box">
      
    </div>
    </div>
  <div class="container-fluid" role="main" >
    <div class="table_main tableShadow">
      <table class="table table-striped table-responsive" >
        <thead>
          <tr class="tbl_name">
            <th *ngIf="serviceType != '100'"> 
              <input type="checkbox" calss = 'myCheckbox' [(ngModel)]="selectAll" (change)="selectAllOrders($event)">
              Select All </th>
            <!-- <th>MRN</th> -->
            <th>Service Type</th>
            <th>Order DID</th>
            <!-- <th>Service Type</th> -->
            <!-- <th>Vendor Name</th> -->
            <!-- <th>Order Created Date</th> -->
            <th>Scheduled Date</th>
            <th>Order Status</th>
            <th >Vendor/Officer Name</th>
            <!-- <th *ngIf="serviceType != '100'" >Officer Assigned</th> -->
            <th >Assessment Completed Date</th>
            <th *ngIf="serviceType != '100'">Payment Status</th>
            <th>Actions &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>
          </tr>
        </thead>
        <tbody>
            <tr *ngFor="let orderDetailsObj of orderDetailsRes;let i = index" >
                <td *ngIf="serviceType != '100'" ><input type='checkbox' calss = 'myCheckbox'  [(ngModel)]="orderDetailsObj.checked" (change)="updateCheckedOrders(orderDetailsObj)"
                  *ngIf="orderDetailsObj?.order?.order_status?.order_status != 8 && orderDetailsObj?.order?.order_status?.order_status != 15 && orderDetailsObj?.order?.order_status?.order_status != 6 "></td>
                <!-- <td>{{orderDetailsObj.order.patientinfo.mrn}}  <p style="color: blue">{{orderDetailsObj.order.patientinfo.corporatename}}</p></td> -->
                <!-- <td>{{orderDetailsObj.order.patientinfo.name}}</td> -->
                <td>
                  <span *ngIf="orderDetailsObj.order.patientinfo.service_type == '3'">
                    Pathology
                  </span>
                  <span *ngIf="orderDetailsObj.order.patientinfo.service_type == '4'">
                    Radiology </span>
                  <span
                    *ngIf="orderDetailsObj.order.patientinfo.service_type == '1' || orderDetailsObj.order.patientinfo.service_type == '10'">
                    Doctor Consultation
                  </span>
                  <span *ngIf="orderDetailsObj.order.patientinfo.service_type == '2'">
                    Medicines
                  </span>
                  <span *ngIf="orderDetailsObj.order.patientinfo.service_type == '5'">
                    Care at Home
                
                  </span>
                  <span *ngIf="orderDetailsObj.order.patientinfo.service_type == '6'">
                    Nursing
                  </span>
                  <span *ngIf="orderDetailsObj.order.patientinfo.service_type == '7'">
                    Physiotherapy
                  </span>
                  <span *ngIf="orderDetailsObj.order.patientinfo.service_type == '8'">
                    Bedside Attendant
                  </span>
                  <span *ngIf="orderDetailsObj.order.patientinfo.service_type == '9'">
                    Speciality
                
                  </span>
                  <span *ngIf="orderDetailsObj.order.patientinfo.service_type == '11'">
                    Medical Equipment Buying & Rental
                
                  </span>
                  <span *ngIf="orderDetailsObj.order.patientinfo.service_type == '12'">
                    Emotional Wellbeing Psychiatry & Psychology
                  </span>
                  <span *ngIf="orderDetailsObj.order.patientinfo.service_type == '13'">
                    Second Opinion
                  </span>
                  <span *ngIf="orderDetailsObj.order.patientinfo.service_type == '14'">
                    MyWellness
                  </span>
                  <span *ngIf="orderDetailsObj.order.patientinfo.service_type == '15'">
                    Family Doctor
                  </span>
                  <span *ngIf="orderDetailsObj.order.patientinfo.service_type == '16'">
                    BloodConnect
                  </span>
                  <span *ngIf="orderDetailsObj.order.patientinfo.service_type == '19'">
                    Diagnostics Others
                  </span>
                  <span *ngIf="orderDetailsObj.order.patientinfo.service_type == '100'">
                    Package
                  </span>
                  <span *ngIf="orderDetailsObj.order.patientinfo.service_type == '20'">
                    Ophthalmology
                  </span>
                  <span *ngIf="orderDetailsObj.order.patientinfo.service_type == '21'">
                    Dental
                  </span>
                  <span *ngIf="orderDetailsObj.mode_of_service == 1">(At Home)</span>
                  <span *ngIf="orderDetailsObj.mode_of_service == 2">(At Center)</span>
                  <span *ngIf="orderDetailsObj.mode_of_service == 3">(At Platform)</span>
                </td>
                <td>{{orderDetailsObj.order.order_status.order_did}}</td>
                
                <td>{{orderDetailsObj.order.patientinfo.scheduled_date | date:'dd/MM/yyyy hh:mm a':'UTC'}}</td>
                <td>{{orderDetailsObj.data.Nomenclature}}</td>
                <td *ngIf="(orderDetailsObj.order.patientinfo.service_type != '5' && orderDetailsObj.order.patientinfo.service_type != '6' && orderDetailsObj.order.patientinfo.service_type != '7' && orderDetailsObj.order.patientinfo.service_type != '8')">
                  <app-diagnostic-center-address [providerInfoObj]="orderDetailsObj.order"></app-diagnostic-center-address>
                </td>
                
                <td *ngIf="(orderDetailsObj.order.patientinfo.service_type == '5' || orderDetailsObj.order.patientinfo.service_type == '6' || orderDetailsObj.order.patientinfo.service_type == '7' || orderDetailsObj.order.patientinfo.service_type == '8')">
                  <span *ngIf="orderDetailsObj.order.order_status.mhoname == undefined || orderDetailsObj.order.order_status.mhoname == null || orderDetailsObj.order.order_status.mhoname == '' ">N/A</span>
                  <span *ngIf=" orderDetailsObj.order.order_status.mhoname != undefined && orderDetailsObj.order.order_status.mhoname != null && orderDetailsObj.order.order_status.mhoname != '' ">{{orderDetailsObj.order.order_status.mhoname}}</span>

                </td>
                <td >
                  <span *ngIf="orderDetailsObj.order.business.assmtCmplTime != undefined && orderDetailsObj.order.business.assmtCmplTime !=''">{{orderDetailsObj.order.business.assmtCmplTime | date:'dd/MM/yyyy hh:mm a'}} </span>
                  <span *ngIf="orderDetailsObj.order.business.assmtCmplTime == undefined">N/A</span>
                </td>
                  <td *ngIf="orderDetailsObj.order.business.is_parent == 1 && serviceType != '100'">
                    <span *ngIf="orderDetailsObj.payment_info.payable_amount == 0">Paid</span>
                    <span *ngIf="orderDetailsObj.payment_info.payable_amount != 0 ">Pending for Payment</span>
                  </td>
                  <td *ngIf="orderDetailsObj.order.business.is_parent != 1 && serviceType != '100'">
                    <span *ngIf="orderDetailsObj.payment_info.paySts==1">Paid</span>
                    <span *ngIf="orderDetailsObj.payment_info.paySts == undefined || orderDetailsObj.payment_info.paySts !== 1">Pending for Payment</span>
                  </td>    
                <td class="view_btn" >
                  <img class="exitImg" src="./assets/img/eye.png"
                    (click)="getOrderById(orderDetailsObj.order.patientinfo.order_id,'orders')" ngbTooltip="View Details"
                    *ngIf=" (orderDetailsObj.order.patientinfo.corporatetype != 'chopd' && orderDetailsObj.order.patientinfo.corporatetype != 'SVAAS')">&nbsp;
                  <img class="exitImg" src="./assets/img/info.png"
                    (click)="opentrackOrderModal(orderDetailsObj.order.patientinfo.order_id)" ngbTooltip="Track History"
                    />
                  <!-- <img class="exitImg" src="./assets/img/download.png"
                    (click)="invoiceDownload(orderDetailsObj.order.patientinfo.order_id)" [disabled]="fileDownloadDisable"
                    ngbTooltip="Download" *ngIf="orderDetailsObj.tenantCode === '1000001' &&  orderDetailsObj.order.patientinfo.service_type == '1'">&nbsp; -->
                    <img class="exitImg" src="./assets/img/send-email.png" width="25px"
                    (click)="openPaymentLinkModal('paymentLink',orderDetailsObj)" ngbTooltip="Send Payment Link"
                    *ngIf=" (orderDetailsObj.order.business.is_parent == 1 && orderDetailsObj.payment_info.payable_amount > 0 )">&nbsp;
                </td>
              </tr>

        </tbody>
      </table>

    </div>
    <div *ngIf="orderDetailsRes.length == 0" class="noRecord"><b>No Records Found</b></div>
    <!-- <div class="col-12 tableBottom" *ngIf="orderDetailsRes?.length">
      <div class="totalRecords">
        Total Orders <span class="fnt-medium">({{totalRecords}})</span>
      </div>
     <div>
      <ngb-pagination [collectionSize]="totalRecords" [(page)]="page" [pageSize]="pageSize" [maxSize]="5"
      [boundaryLinks]="true" class=" customPagination" (pageChange)="pageChange(page)">
    </ngb-pagination>
     </div> 
    </div> -->

  </div>
  <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
    <p style="color: white">Please Wait. </p>
  </ngx-spinner>

  
</section>